import { render, staticRenderFns } from "./positionText.vue?vue&type=template&id=7e46f804&scoped=true"
import script from "./positionText.vue?vue&type=script&lang=js"
export * from "./positionText.vue?vue&type=script&lang=js"
import style0 from "./positionText.vue?vue&type=style&index=0&id=7e46f804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e46f804",
  null
  
)

export default component.exports